import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFilter2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconFilter2"><Path fillRule="evenodd" clipRule="evenodd" d="M2 4.5C2 4.22386 2.22386 4 2.5 4H21.5C21.7761 4 22 4.22386 22 4.5C22 4.77614 21.7761 5 21.5 5H2.5C2.22386 5 2 4.77614 2 4.5ZM5 12C5 11.7239 5.22386 11.5 5.5 11.5H18.5C18.7761 11.5 19 11.7239 19 12C19 12.2761 18.7761 12.5 18.5 12.5H5.5C5.22386 12.5 5 12.2761 5 12ZM8 19.5C8 19.2239 8.22386 19 8.5 19H15.5C15.7761 19 16 19.2239 16 19.5C16 19.7761 15.7761 20 15.5 20H8.5C8.22386 20 8 19.7761 8 19.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFilter2;
